import React, { useRef } from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { GlobalDocumentIds } from '../../../../types/GlobalDocumentIds';

type CloseAllSubPanelsButton = {
  closeAllSubPanels: () => void;
};

/**
 * The X-Button. Closes all sub panels.
 */
export function CloseAllSubPanelsButton({ closeAllSubPanels }: CloseAllSubPanelsButton) {
  const { t } = useSonTranslation('MainNavigation');
  const closeAllButtonRef = useRef<HTMLButtonElement>(null);
  const buttonName = t('subPanels.closeAllSubPanelsButton');

  return (
    <Tooltip attachTo={closeAllButtonRef} hideTooltipFromScreenReader placement={TooltipPlacement.RIGHT} hideOnClick>
      <button
        type="button"
        ref={closeAllButtonRef}
        className="main-navigation__sub-panel-button"
        aria-controls={GlobalDocumentIds.mainNavigationSubPanelContainer}
        title={buttonName}
        onClick={(event: React.MouseEvent) => {
          event.preventDefault();
          event.stopPropagation();
          closeAllSubPanels();
        }}
      >
        <span className="invisible">{buttonName}</span>
        <SVG svgSpriteId={Icons.DECLINE_CROSS} />
      </button>
    </Tooltip>
  );
}
